import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export const useApiSearchAcademies = (args, config) => {
    return useQuery({
        queryKey: ['public', 'academy', 'search', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (data = {}) => {
            return generalRequest.get(`/academies`, {params: data});
        })({...args, page: pageParam})),
    })
}

export function useApiSearchAcademiesOld(args) {
    return useQuery({
        queryKey: ['active', 'academies'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/academies`, {params: data});
        })(args))
    })
}


export function useApiReadAcademyId(academyId) {
    return useQuery({
        queryKey: ['active', 'detail', 'academies', academyId],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/academies/${id}`)
        })(academyId))
    })
}
